import { Icon, makeStyles } from '@fluentui/react';
import React from 'react';
import ApprovedIcon from '../../../../assets/svgs/ApproveStatusIcons/Approved.svg?react';
import ApprovedPendingIcon from '../../../../assets/svgs/ApproveStatusIcons/ApprovedPending.svg?react';
import CanceledIcon from '../../../../assets/svgs/ApproveStatusIcons/Canceled.svg?react';
import DeclinedIcon from '../../../../assets/svgs/ApproveStatusIcons/Declined.svg?react';
import DeclinedPendingIcon from '../../../../assets/svgs/ApproveStatusIcons/DeclinedPending.svg?react';
import DraftIcon from '../../../../assets/svgs/ApproveStatusIcons/Draft.svg?react';
import PendingIcon from '../../../../assets/svgs/ApproveStatusIcons/Pending.svg?react';

const useStyles = makeStyles((theme) => ({
  logo: {
    fill: theme.palette.neutralPrimary,
  },
}));

interface GetStatusParam {
  status: string;
}

export const RenderIcon: React.FC<GetStatusParam> = ({ status }) => {
  const styles = useStyles();

  switch (status) {
    case 'REJECTED':
      return <DeclinedIcon />;
    case 'VOIDED':
    case 'AMENDED':
    case 'CANCELED':
      return <CanceledIcon />;
    case 'REJECTED_PENDING':
      return <DeclinedPendingIcon />;
    case 'ENTERED':
      return <Icon className={styles.logo} iconName="Stamp" />;
    case 'APPROVED':
      return <ApprovedIcon />;
    case 'APPROVED_PENDING':
      return <ApprovedPendingIcon />;
    case 'PENDING':
      return <PendingIcon />;
    default:
      return <DraftIcon />;
  }
};
